import React, { useEffect } from "react";
import "./JobInfoComponent.css";
import Breadcrumb_comp from "../../Common-Component/Breadcrumb_comp/Breadcrumb_comp";
import { getCareerById } from "../../../features/career/careerSlice";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import parse from "html-react-parser";

const JobInfoComponent = ({careers}) => {
  // const { id } = useParams();
  // const careers = useSelector((state) => state.career.addCareerById);
  // const dispatch = useDispatch();

  // useEffect(() => {
  //   if (id) {
  //     dispatch(getCareerById(id));
  //   }
  // }, [dispatch, id]);


  const breadcrumbData = [
    { name: "Home", link: "/home" },
    { name: "Career" }, // No link for the last item (active)
  ];

  return (
    <section className="JobInfoComponent">
      <div className="Breadcrumb_div">
        <Breadcrumb_comp data={breadcrumbData} />
      </div>

      <div className="job_role">
        <p className="heading_text">Job Role:</p>
        <p className="sub_text">{careers.job_name}</p>
      </div>

      <div className="roles_div">
        <p className="title">Roles and Responsibilities:</p>

        <div className="inner_content_div">
          <p className="content_text">
            {careers.roles_and_responsibility ? parse(careers.roles_and_responsibility) : ""}
          </p>
        </div>
      </div>

      <div className="roles_div">
        <p className="title">Skills Required:</p>

        <div className="inner_content_div">
          <p className="content_text">   {careers.skills_required ? parse(careers.skills_required) : ""}</p>
        </div>
      </div>
    </section>
  );
};

export default JobInfoComponent;
